import React, { useRef } from "react";
import Page from "../../page";
import InvestorProfile from "../profile";
import InvestorSuitability from "../suitability";
import { AlertWithModal } from "../../../ui";
import Card from "../../../ui/card";
import { OpenModalLink } from "../../../ui/modal/Styled";

const ShowInvestor = () => {
  const profileRef = useRef();

  return (
    <Page crumbs={[{ title: "Meu perfil" }]} title="Meu perfil">
      <Card>
        <h4>Perfil de Investidor</h4>

        <div className="col-sm-12 pl-0 pr-0">
          <AlertWithModal
            ref={profileRef}
            alertMessage={
              <span>
                Se você já respondeu o questionário de Perfil de Investidor e
                deseja refazê-lo,{" "}
                <OpenModalLink
                  onClick={() => profileRef.current.setShowModal(true)}
                >
                  clique aqui
                </OpenModalLink>
                !
              </span>
            }
            modalTitle="Perfil de Investidor"
            modalContent={
              <InvestorSuitability
                onSuccess={() => profileRef.current.setShowModal(false)}
              />
            }
            backdrop
            keyboard
          />
        </div>
      </Card>

      <Card>
        <InvestorProfile buttonLabel="Atualizar" />
      </Card>
    </Page>
  );
};

export default ShowInvestor;
